import React, { useState } from "react";
import { useParams } from "react-router";
import { Splide, SplideSlide } from "@splidejs/react-splide";
import "@splidejs/react-splide/css";

import styles from "./NftDetail.module.css";
import img from "../../Assets/card-img.jpg";
import ether from "../../Assets/ether.png";
import { useEffect } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import Loading from "../../Components/Loading/Loading";
import isEmpty from "../../utils/is-empty";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEthereum } from "@fortawesome/free-brands-svg-icons";
import { faEye } from "@fortawesome/free-regular-svg-icons";
import { faArrowUp, faXmark } from "@fortawesome/free-solid-svg-icons";
import { useSelector } from "react-redux";
function NftDetail() {
  const { id } = useParams();
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState({});
  const [modal, setModal] = useState(false);
  const [modalForm, setModalForm] = useState({
    name: "",
    email: "",
    num: "",
    message: "",
  });
  const { address: walletAddress } = useSelector((state) => state.wallet);
  useEffect(() => {
    axios
      .get(`/asset/${id}`)
      .then((res) => {
        setData(res.data);
      })
      .catch((err) => {
        toast.error("Uh Oh! Something went wrong");
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [id]);
  const formHandler = (e) => {
    e.preventDefault();
    axios
      .post("/asset/message", {
        emailId: modalForm.email,
        fromWalletAddress: walletAddress,
        message: modalForm.message,
        name: modalForm.name,
        phNo: modalForm.num,
        toWalletAddress: data.asset.ownerAddress,
        tokenId: id,
      })
      .then((res) => toast.success("Message Sent"))
      .catch((err) => {
        toast.error("Uh Oh! Something went wrong");
      })
      .finally(() => setModal(false));
  };
  return (
    <div className="container">
      {modal && (
        <>
          <div onClick={() => setModal(false)} className={styles.overlay}></div>
          <div className={styles.modal}>
            <FontAwesomeIcon onClick={() => setModal(false)} icon={faXmark} />
            <h1>Send Message</h1>
            <form onSubmit={formHandler}>
              <div className={styles.modalDiv}>
                <label htmlFor="name">Full Name</label>
                <input
                  value={modalForm.name}
                  onChange={(e) =>
                    setModalForm((prev) => {
                      return { ...prev, name: e.target.value };
                    })
                  }
                  type="text"
                  id="name"
                  required
                />
              </div>
              <div className={styles.modalDiv}>
                <label htmlFor="email">Email</label>
                <input
                  value={modalForm.email}
                  onChange={(e) =>
                    setModalForm((prev) => {
                      return { ...prev, email: e.target.value };
                    })
                  }
                  type="email"
                  id="email"
                  required
                />
              </div>
              <div className={styles.modalDiv}>
                <label htmlFor="num">Phone Number</label>
                <input
                  value={modalForm.num}
                  onChange={(e) =>
                    setModalForm((prev) => {
                      return { ...prev, num: e.target.value };
                    })
                  }
                  type="number"
                  id="number"
                  required
                />
              </div>
              <div className={styles.modalDiv}>
                <label htmlFor="num">Message</label>
                <textarea
                  value={modalForm.message}
                  onChange={(e) =>
                    setModalForm((prev) => {
                      return { ...prev, message: e.target.value };
                    })
                  }
                  id="message"
                  required
                ></textarea>
              </div>
              <button type="submit" className="cta-btn">
                Send
              </button>
            </form>
          </div>
        </>
      )}
      {isLoading && <Loading />}
      {data && (
        <>
          <div className={styles.nftDetail}>
            <h1 className={styles.nftName}>{data?.asset?.name}</h1>
            <div className={styles.imgDiv}>
              <img src={data?.asset?.imageUrl} alt="" />
              <div className={styles.imgCol}>
                <img src={data?.asset?.imageUrl} alt="" />
                <img src={data?.asset?.imageUrl} alt="" />
              </div>
            </div>
            <Splide
              options={{
                rewind: true,
                gap: "0rem",
                perPage: 1,
                type: "loop",
                pagination: true,
                drag: true,
                arrows: false,
                width: "100%",
              }}
              className={styles.mobileSlider}
            >
              <SplideSlide>
                <img src={data?.asset?.imageUrl} alt="" />
              </SplideSlide>
              <SplideSlide>
                <img src={data?.asset?.imageUrl} alt="" />
              </SplideSlide>
              <SplideSlide>
                <img src={data?.asset?.imageUrl} alt="" />
              </SplideSlide>
            </Splide>
            <div className={styles.bottomNft}>
              <div className={styles.descNft}>
                <ul>
                  <li>7 bd</li>
                  <li>3 ba</li>
                  <li>2,605 sqft</li>
                  <li>16,552 sq. ft.</li>
                  <li>HOA dues </li>
                  <li>Active</li>
                </ul>
                <p className={styles.mainDesc}>{data?.asset?.description}</p>
                <h6>Listed By Ava Weaver, Crown City Management Brokers</h6>
                <h1>Features</h1>
                <div className={styles.featureDiv}>
                  <div className={styles.col}>
                    <h3>On Opendoor</h3>
                    <p>7</p>
                  </div>
                  <div className={styles.col}>
                    <h3>Type</h3>
                    <p>{data?.asset?.type}</p>
                  </div>
                  <div className={styles.col}>
                    <h3>City</h3>
                    <p>{data?.asset?.city}</p>
                  </div>
                  <div className={styles.col}>
                    <h3>Home size</h3>
                    <p>{data?.asset?.sqft}</p>
                  </div>
                  <div className={styles.col}>
                    <h3>Built in</h3>
                    <p>{data?.asset?.yearBuilt}</p>
                  </div>
                  <div className={styles.col}>
                    <h3>Lot size</h3>
                    <p>{data?.asset?.lotSqft}</p>
                  </div>
                  <div className={styles.col}>
                    <h3>Price per sqft</h3>
                    <p>7</p>
                  </div>
                  <div className={styles.col}>
                    <h3>Beds</h3>
                    <p>{data?.asset?.beds}</p>
                  </div>
                  <div className={styles.col}>
                    <h3>Baths</h3>
                    <p>{data?.asset?.bath}</p>
                  </div>
                </div>
                <div className={styles.btnDiv}>
                  <button className="cta-btn">Get More Info</button>
                  <button className="cta-btn">Start an offer</button>
                </div>
                {!isEmpty(data.priceHistory) && (
                  <div
                    className={`${styles.moreDetails} ${styles.overflowTable}`}
                  >
                    <hr className={styles.hr} />
                    <h2>Price History</h2>
                    <table className={styles.table}>
                      <tr>
                        <th>Event Date</th>
                        <th>Event</th>
                        <th>Price</th>
                        <th>Price Per Sqt</th>
                        <th>Rental</th>
                      </tr>
                      {data.priceHistory.map((el, idx) => {
                        return (
                          <tr key={"pric-hisgfsw" + idx}>
                            <td>{el.eventDate}</td>
                            <td>{el.event}</td>
                            <td>{el.price}</td>
                            <td>{el.pricePerSqt}</td>
                            <td>{el.rental.toString()}</td>
                          </tr>
                        );
                      })}
                    </table>
                  </div>
                )}
                {!isEmpty(data.taxHistory) && (
                  <div
                    className={`${styles.moreDetails} ${styles.overflowTable}`}
                  >
                    <hr className={styles.hr} />
                    <h2>Tax History</h2>
                    <table className={styles.table}>
                      <tr>
                        <th>Event Date</th>
                        <th>Tax Paid</th>
                        <th>Value</th>
                        <th>Value Increase Rate</th>
                        <th>Tax Increase Rate</th>
                      </tr>
                      {data.taxHistory.map((el, idx) => {
                        return (
                          <tr key={"tax-history" + idx}>
                            <td>{el.eventDate}</td>
                            <td>{el.taxPaid}</td>
                            <td>{el.value}</td>
                            <td>{el.valueIncreaseRate}</td>
                            <td>{el.taxIncreaseRate}</td>
                          </tr>
                        );
                      })}
                    </table>
                  </div>
                )}
                {!isEmpty(data.schoolListings) && (
                  <div className={styles.moreDetails}>
                    <hr className={styles.hr} />
                    <h2>Schools</h2>

                    {data.schoolListings.map((el, idx) => {
                      return (
                        <a
                          key={"school" + idx}
                          href={el.link}
                          target={"blank"}
                          className={styles.moreDetailsRow}
                        >
                          <p>
                            {el.name}, {el.grades}, {el.distance}
                          </p>
                          <h3>{el.rating}</h3>
                        </a>
                      );
                    })}
                  </div>
                )}
              </div>
              <div className={styles.stickyBox}>
                <div className={styles.boxWrapper}>
                  <div className={styles.owner}>
                    <img src={img} alt="" />
                    <div className={styles.ownerDetails}>
                      <h2>Current Owner</h2>
                      <p>{data?.asset?.ownerAddress}</p>
                    </div>
                  </div>
                  <div className={styles.listOwner}>
                    <a href="#" target={"blank"}>
                      <FontAwesomeIcon icon={faEthereum} /> Ethereum (ERC-721)
                    </a>
                    <a href="#" target={"blank"}>
                      <img src={ether} alt="" /> View on Etherscan{" "}
                      <FontAwesomeIcon className={styles.up} icon={faArrowUp} />
                    </a>
                    <a href="#" target={"blank"}>
                      <FontAwesomeIcon icon={faEye} /> Open orignal on IPFS{" "}
                      <FontAwesomeIcon className={styles.up} icon={faArrowUp} />
                    </a>
                  </div>
                  <div className={styles.boxDesc}>
                    <h3>Estimate</h3>
                    <p>$</p>
                  </div>
                  <button onClick={() => setModal(true)} className="cta-btn">
                    Message
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className={styles.mobBox}>
            <div className={styles.boxCol}>
              <h3>$489,900</h3>
              <p>List price $489,900</p>
            </div>
            <button className="cta-btn">Start an offer</button>
          </div>
        </>
      )}
    </div>
  );
}

export default NftDetail;
